<template>
  <PopupBox
    :disable="disable"
    class="menu-dropdown"
    :popup-styles="{ top: -5 }"
    :placement="isDesktop ? 'bottom-end' : 'bottom-start'"
    @visibility-change="handlePopupVisibilityChange"
  >
    <template v-slot:trigger>
      <p
        :class="clsx(
          'menu-dropdown__trigger',
          {
            'menu-dropdown__trigger--active': hasActiveFilters && highlightActive,
            'menu-dropdown__trigger--disabled': disable
          }
        )"
      >
        <slot />
        <PopupToggler
          v-if="!hideIcon"
          :is-open="popupVisible"
          :color="calculateTogglerColor"
          class="menu-dropdown__toggler"
        />
      </p>
    </template>

    <template>
      <div class="menu-dropdown__menu">
        <PopupMenuList
          :items="items"
          :selected-item="selectedItem"
          :checkbox-style="checkboxStyle"
        />
      </div>
    </template>
  </PopupBox>
</template>

<script>
import clsx from 'clsx';
import { mapGetters } from 'vuex';
import { PopupBox, PopupMenuList, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: Object,
      default: () => ({}),
    },
    checkboxStyle: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'styled'].includes(value),
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    highlightActive: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [popupToggle],
  components: { PopupBox, PopupToggler, PopupMenuList },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
    hasActiveFilters() {
      if (!this.selectedItem?.id) return false;
      const correspondingItem = this.items.find(
        (item) => item.id === this.selectedItem.id
      );
      return correspondingItem?.options?.activeFilter !== false;
    },
    calculateTogglerColor() {
      if (this.disable) {
        return '#6B7280';
      }
      return this.hasActiveFilters ? '#FB923C' : '#09090B';
    },
  },
  methods: { clsx },
};
</script>

<style scoped lang="scss">
.menu-dropdown {
  display: inline-block;
}

.menu-dropdown__trigger {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.2s ease, background-color 0.2s ease;

  &:hover:not(.menu-dropdown__trigger--disabled) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  &--active {
    color: #fb923c;
  }

  &--disabled {
    cursor: not-allowed;
    color: #6b7280;
    background-color: #f3f4f6;
  }
}

.menu-dropdown__toggler {
  margin-left: 8px;
}

.menu-dropdown__menu {
  min-width: 200px;
  max-width: 300px;
  max-height: 400px;
  overflow-y: auto;
}
</style>
